import { set } from 'lodash';
import { MutationTree } from 'vuex';

export const state = () => ({
  id: null,
  form: {
    readonly: false
  },
  query: {
    where: {
      purchaseType: ['STOCK', 'PREORDER', 'UNLOCK']
    },
    sort: {
      createdAt: 'DESC'
    },
    offset: 0,
    limit: 10
  },
  table: {
    footer: {
      'items-per-page-options': [10, 25, 50, 100],
      'show-current-page': true,
      'show-first-last-page': true,
      'page-text': '{{pageStart}}',
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      }
    },
    filter: {
      title: '',
      description: '',
      purchaseType: ['STOCK', 'PREORDER', 'UNLOCK']
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['order'],
      sortDesc: [false],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: true
    }
  }
});

export type ProductType = ReturnType<typeof state>;

export const mutations: MutationTree<ProductType> = {
  changeId: (state, id) => (state.id = id),
  changeForm: (state, form) => Object.assign(state.form, form),
  changeQuery: (state, query) => Object.assign(state.query, query),
  changeTableFilter: (state, filter) => {
    Object.assign(state.table, { filter });
    Object.assign(state.query.where, {
      title: filter.title,
      description: filter.description,
      purchaseType: filter.purchaseType
    });
  },
  changeTableOptions: (state, options) => {
    Object.assign(state.table, { options });
    Object.assign(state.table.footer, { options });
    Object.assign(state.query, {
      sort: set({}, options.sortBy[0], options.sortDesc[0] ? 'DESC' : 'ASC'),
      limit: options.itemsPerPage,
      offset: (options.page - 1) * options.itemsPerPage
    });
  }
};
